import axios from 'axios'
import { getToken } from '../token/store'

const baseURL = 'https://api.filecharkh.com/'

export const config = () => {
    axios.defaults.baseURL = baseURL
    axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
    axios.defaults.headers.common['Authorization'] = getToken()
    // axios.defaults.withCredentials = true
}


export const me = 'api/v1/user/me'
export const services = 'api/v1/service/list'
export const orders = 'api/v1/serviceOrder/orders'
export const servicesInfo = 'api/v1/serviceInfo/list?serviceId=:serviceId'
export const addOrder = 'api/v1/serviceOrder/addOrder?infoId=:infoId'
export const payments = 'api/v1/payment/wallet/history'

export const payment = 'https://api.filecharkh.com/api/v1/payment/wallet/request?amount=:amount&phone=:phone'










